import React from 'react';

/* eslint-disable */
export default props => (
  <svg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 94.1 62.1'>
    <path d='M9.4,0h75.3c2.6,0,4.9,1.1,6.6,2.8v0c1.7,1.7,2.8,4.1,2.8,6.6v43.3c0,2.6-1.1,4.9-2.8,6.6v0	c-1.7,1.7-4.1,2.8-6.6,2.8H9.4c-2.6,0-4.9-1.1-6.6-2.8l0,0C1.1,57.6,0,55.3,0,52.7V9.4c0-2.6,1.1-4.9,2.8-6.6v0C4.5,1.1,6.8,0,9.4,0	L9.4,0z M14.5,42.9h21.7c0.7,0,1.3,0.6,1.3,1.3v3.4c0,0.7-0.6,1.3-1.3,1.3H14.5c-0.7,0-1.3-0.6-1.3-1.3v-3.4	C13.2,43.5,13.8,42.9,14.5,42.9L14.5,42.9z M6.3,13.3h81.5V9.4c0-0.8-0.3-1.6-0.9-2.2l0,0c-0.6-0.6-1.3-0.9-2.2-0.9H9.4	c-0.8,0-1.6,0.3-2.2,0.9l0,0C6.7,7.8,6.3,8.6,6.3,9.4V13.3L6.3,13.3z M87.8,25.1H6.3v27.6c0,0.9,0.3,1.6,0.9,2.2	c0.6,0.6,1.3,0.9,2.2,0.9h75.3c0.8,0,1.6-0.3,2.2-0.9l0,0c0.6-0.6,0.9-1.3,0.9-2.2V25.1L87.8,25.1z'
    />
  </svg>
)

/* eslint-enable */
